export default "__VITE_ASSET__Ck_5rVrp__"